import { IonIcon } from '@ionic/react';
import { personOutline } from 'ionicons/icons';
import { withAvatarCacheBuster } from '../../lib/avatarUrl';
import { cn } from '../../lib/utils';

interface UserAvatarProps {
  picture?: string | null;
  /** User's updatedAt, used to cache-bust the avatar after a re-upload. */
  updatedAt?: string | null;
  name?: string | null;
  /** Rendered size in pixels (width = height). */
  size?: number;
  className?: string;
}

/**
 * Circular avatar for app users (league members, post authors, …). Shows the
 * profile picture when there is one, otherwise a neutral person icon — never
 * initials — matching the "default person icon" fallback used across the app.
 */
export const UserAvatar = ({
  picture,
  updatedAt,
  name,
  size = 44,
  className,
}: UserAvatarProps) => {
  const src = withAvatarCacheBuster(picture, updatedAt);

  return (
    <div
      className={cn(
        'flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-slate-200 text-slate-400',
        className
      )}
      style={{ width: size, height: size }}
    >
      {src ? (
        <img src={src} alt={name ?? 'Avatar'} className="h-full w-full object-cover" />
      ) : (
        <IonIcon
          icon={personOutline}
          aria-label={name ?? 'Avatar'}
          style={{ fontSize: Math.round(size * 0.55) }}
        />
      )}
    </div>
  );
};
